import React, { createContext, useState, useContext, ReactNode } from 'react';

interface BulkCounts {
  pendingBulkCount: number;
  // Add other bulk-related counts as needed
  // Example: processedBulkCount: number;
  // Example: failedBulkCount: number;
}

interface BulkCountContextValue {
  bulkCounts: BulkCounts;
  updateBulkCounts: (counts: BulkCounts) => void;
}

export const BulkCountContext = createContext<BulkCountContextValue | undefined>(undefined);

interface BulkCountProviderProps {
  children: ReactNode;
}

export const BulkCountProvider: React.FC<BulkCountProviderProps> = ({ children }) => {
  const [bulkCounts, setBulkCounts] = useState<BulkCounts>({
    pendingBulkCount: 0,
    // Initialize other bulk counts here if needed
    // processedBulkCount: 0,
    // failedBulkCount: 0,
  });

  const updateBulkCounts = (counts: BulkCounts) => {
    setBulkCounts(counts);
  };

  return (
    <BulkCountContext.Provider value={{ bulkCounts, updateBulkCounts }}>
      {children}
    </BulkCountContext.Provider>
  );
};

export const useBulkCount = () => {
  const context = useContext(BulkCountContext);
  if (!context) {
    throw new Error('useBulkCount must be used within a BulkCountProvider');
  }
  return context;
};